import React from 'react'
import { LinkNavigation } from 'shared-global-ec-uikit/components/dist/react/esm'
import { FormattedMessage } from 'react-intl'
import { oneTrustOnClick } from 'helpers/oneTrust'

type Props = {
  oneTrustLabel: string
}

const OneTrustFooter = ({ oneTrustLabel }: Props) => {
  return (
    <LinkNavigation
      variant="TitleSmall"
      element="button"
      onClick={oneTrustOnClick}
    >
      <FormattedMessage id={oneTrustLabel} />
    </LinkNavigation>
  )
}

export default OneTrustFooter
